module.exports = __webpack_public_path__ + "img/lb5.66511851.jpg";